// Drop the leading warehouse short-code segment ("NP-", "PD-", "PL-") from
// a location shown to the picker. The picker is already inside one
// warehouse, so the prefix is wasted width — we only want the
// aisle-bay-level part.
//
// The list is EXHAUSTIVE on purpose. A "any 2–3 letters" rule silently ate
// real aisle codes: "AA-54-L4" rendered as "54-L4", sending pickers to the
// wrong aisle. Aisle names and warehouse codes are the same shape, so only
// an exact known-code match is safe. A location that is nothing but its
// warehouse prefix is left alone rather than blanked.
export const WAREHOUSE_PREFIXES = ["NP", "PD", "PL"];

export const stripWarehouse = (loc: string): string => {
    for (const code of WAREHOUSE_PREFIXES) {
        const prefix = `${code}-`;
        if (loc.startsWith(prefix) && loc.length > prefix.length) {
            return loc.slice(prefix.length);
        }
    }
    return loc;
};
